module.exports = __webpack_public_path__ + "static/media/YM54_9.d496dd1b.jpg";